<!-- Nav Start -->
<nav
        [class.darkHeader]="darkHeader"
        class="navbar navbar-expand-lg navbar-light theme-nav fixed-top">

    <div class="container nav-container">

        <a [routerLink]="languageService.route('/day')" class="navbar-brand brand">
            <img
                    alt="Mondkalender"
                    class="logo"
                    src="assets/images/moon/moon_4.webp">

            <span class="brand-name">
                {{ 'MENU.TITLE' | translate }}
            </span>
        </a>

        <button
                (click)="isOpenMobile = !isOpenMobile"
                [attr.aria-expanded]="isOpenMobile"
                aria-controls="navbarSupportedContent"
                aria-label="Toggle navigation"
                class="navbar-toggler"
                type="button">

            <span class="navbar-toggler-icon"></span>
        </button>

        <div
                [class.show]="isOpenMobile"
                class="collapse navbar-collapse default-nav"
                id="navbarSupportedContent">

            <div class="nav-shell">

                <ul class="navbar-nav main-menu" id="mymenu">

                    <li class="nav-item">
                        <a
                                (click)="active('day')"
                                [ngClass]="{'active': activeClass === 'day'}"
                                class="nav-link"
                                [routerLink]="languageService.route('/day')">

                            {{ 'MENU.DAY' | translate }}
                        </a>
                    </li>

                    <li class="nav-item">
                        <a
                                (click)="active('information')"
                                [ngClass]="{'active': activeClass === 'information'}"
                                class="nav-link"
                                [routerLink]="languageService.route('/information')">

                            {{ 'MENU.INFORMATION' | translate }}
                        </a>
                    </li>

                    <li class="nav-item">
                        <a
                                (click)="active('month')"
                                [ngClass]="{'active': activeClass === 'month'}"
                                class="nav-link"
                                [routerLink]="languageService.route('/month')">

                            {{ 'MENU.MONTH' | translate }}
                        </a>
                    </li>

                    <li class="nav-item">
                        <a
                                (click)="active('search')"
                                [ngClass]="{'active': activeClass === 'search'}"
                                class="nav-link"
                                [routerLink]="languageService.route('/search')">

                            {{ 'MENU.SEARCH' | translate }}
                        </a>
                    </li>

                    <li class="nav-item">
                        <a
                                (click)="active('app')"
                                [ngClass]="{'active': activeClass === 'app'}"
                                class="nav-link"
                                [routerLink]="languageService.route('/app')">

                            {{ 'MENU.APP' | translate }}
                        </a>
                    </li>

                </ul>

                <mat-button-toggle-group
                        class="seg-switch"
                        hideSingleSelectionIndicator="true"
                        [value]="language"
                        (change)="setLanguage($event.value)">

                    <mat-button-toggle value="de">
                        {{ 'LANGUAGE.GERMAN' | translate }}
                    </mat-button-toggle>

                    <mat-button-toggle value="en">
                        {{ 'LANGUAGE.ENGLISH' | translate }}
                    </mat-button-toggle>

                </mat-button-toggle-group>

            </div>

        </div>
    </div>
</nav>
<!-- Nav End -->
